import _orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';

import type { RootReducerStateT } from 'app/reducers/rootReducer';
import type { LanguageT } from 'components/powerCallFlow/reducers/flowLanguages';

const getFlowLanguages = (state: RootReducerStateT): LanguageT[] =>
  state.flowLanguages.languages;

export const getLastUsedEmailIntegration = (
  state: RootReducerStateT,
): string | null => state.settings.personal.lastUsedEmailIntegration;

/* SELECTORS */
export const selectFlowLanguagesSorted = createSelector(
  getFlowLanguages,
  (languages: LanguageT[]): LanguageT[] =>
    _orderBy(
      languages,
      [(language: LanguageT) => language.label.toLowerCase()],
      'asc',
    ),
);
